import React from 'react'
import { PaymentFailure } from '../PaymentResult'

export default function ReceiptFailure({ visible, chargeId, message }) {
    if (!visible) {
        return null
    }

    return <PaymentFailure visible={true} chargeId={chargeId} message={message} />
}
